import Pagination from './pagination';
import MemberPopup from './member-popup';
import BlogSearch from './blog_search';

const $ = jQuery.noConflict();

'use strict';
const LoadMorePosts = {
	$domScrollLoader: null,
	$domBlockPosts: null,
	$domStatus: null,
	$domTax: null,
	page: 1,
	maxPages: window.fwsMaxPages,
	$domUrl: $('body').data('url'),
	init: function() {
		if ($('.js-hidden-status').length < 1) {
			return;
		}
		LoadMorePosts.initProperty();
		LoadMorePosts.showPage();
		// generate pagination on the first page load
		if (LoadMorePosts.maxPages) {
			Pagination.generatePagination(LoadMorePosts.maxPages, LoadMorePosts.page);
		}
	},

	showPage: ()=>{
		const pageNum = LoadMorePosts.getPageNumber();
		if (MemberPopup.getUrlParameter('cat')) return;

		// send request
		LoadMorePosts.page = pageNum;
		LoadMorePosts.loadMorePosts(
			LoadMorePosts.prepareData(pageNum)
		);
	},

	getPageNumber: ()=>{
		const path = window.location.pathname;
		const match = path.match(/\/page\/(\d+)\//);
		console.log(match ? parseInt(match[1], 10) : 1);
		return match ? parseInt(match[1], 10) : 1;
	},

	initProperty: ()=>{
		LoadMorePosts.$domScrollLoader = $('.js-loader');
		LoadMorePosts.$domBlockPosts = $('.js-block-posts');
		LoadMorePosts.$domStatus = $('.js-hidden-status').val();
		LoadMorePosts.$domTax = $('.js-hidden-tax').val();
	},

	loadMorePosts: function(data) {
		$.ajax({
			method: 'POST',
			url: window.fwsLocalized.ajaxUrl,
			data: data,
			success: function(response) {
				LoadMorePosts.appendPosts(response);
				//
				if (response.data.posts) {
					// generate pagination
					Pagination.generatePagination(response.data.max, LoadMorePosts.page);
					// change url address
					LoadMorePosts.changeUrl(LoadMorePosts.page);
				} else { // show no results
					// $('#fws-lf-pagination').empty();
					$('.js-post-container').empty();
					$('.js-post-container').append('<div class="blog-cards__no-content js-blog-post-message">\n' +
						'<h3 class="pre-title--small">Sorry, no results were found</h3>\n' +
						'</div>');
				}
			}, complete: ()=> {
				BlogSearch.showLoader(true);
			}
		});
	},

	appendPosts: (response)=>{
		$('.js-block-posts').empty();
		$('.js-block-posts').append(response.data.posts);
	},

	changeUrl: (page, status = '')=> {
		if (MemberPopup.getUrlParameter('cat')) return;

		// push page to url
		const param = status === 'search' ? '' : 'page/' + page + '/';
		const url = LoadMorePosts.$domUrl + param;
		window.history.pushState('', '', url);
	},

	prepareData: (paged = 1)=>{
		const formValues = [];
		formValues.push({name: 'action', value: 'loadMorePosts'});
		formValues.push({name: 'paged', value: paged});
		formValues.push({name: 'tax', value: $('.js-hidden-tax').val()});
		formValues.push({name: 'status', value: $('.js-hidden-status').val()});
		// return data
		return formValues;
	},
};

export default LoadMorePosts;
